export const useProductGroupsStore = defineStore('productGroups', {
  state: () => ({
    productGroups: null as PaginatedProductGroup | null,
  }),
  getters: {
    getProductGroups: (state) => (state.productGroups !== null ? state.productGroups.items : []),
  },
  actions: {
    setProductGroups(productGroups: PaginatedProductGroup) {
      useLocalStorage().setItem('productGroups', productGroups);
      this.productGroups = productGroups;
    },
    async createProductGroup(
      productGroup: ProductGroupCreateUpdate,
    ): Promise<ProductGroup | undefined> {
      try {
        const {data} = await apiPostProductGroup(productGroup);
        // Push the object to state.
        if (this.productGroups !== null) {
          this.productGroups.items.push(data);
          useLocalStorage().setItem('productGroups', this.productGroups);
        }
        return data;
      } catch (error) {
        throw apiErrorMessage(error);
      }
    },
    async readProductGroups(
      limit: number = 500,
      offset: number = 0,
    ): Promise<PaginatedProductGroup | undefined> {
      // Parse the local storage value & set the state.
      const localStorageProductGroups: PaginatedProductGroup | null =
        useLocalStorage().getItem('productGroups');
      if (localStorageProductGroups) this.setProductGroups(localStorageProductGroups);
      try {
        const {data} = await apiGetProductGroups(limit, offset);
        this.setProductGroups(data);
        return data;
      } catch (error) {
        throw apiErrorMessage(error);
      }
    },
    async readProductGroupById(id: string | number): Promise<ProductGroup | undefined> {
      // Parse & return the local storage value.
      const localStorageProductGroups: PaginatedProductGroup | null =
        useLocalStorage().getItem('productGroups');
      if (localStorageProductGroups) {
        const foundProductGroup = localStorageProductGroups.items.find((p) => p.id === id);
        if (foundProductGroup !== undefined) return foundProductGroup;
      }
      try {
        const {data} = await apiGetProductGroup(id);
        return data;
      } catch (error) {
        throw apiErrorMessage(error);
      }
    },
    async updateProductGroup(
      productGroup: ProductGroupCreateUpdate,
    ): Promise<ProductGroup | undefined> {
      try {
        const response = await apiPutProductGroup(productGroup);
        const data: ProductGroup = response.data;
        // Find & update the target object.
        if (this.productGroups !== null) {
          const index = this.productGroups.items.findIndex((p) => p.id === data.id);
          if (index >= 0) {
            Object.assign(this.productGroups.items[index], data);
            useLocalStorage().setItem('productGroups', this.productGroups);
          }
        }
        return data;
      } catch (error) {
        throw apiErrorMessage(error);
      }
    },
    async deleteProductGroup(id: string | number): Promise<ProductGroup | undefined> {
      try {
        const {data} = await apiDeleteProductGroup(id);
        // Find & remove the element.
        if (this.productGroups !== null) {
          const index = this.productGroups.items.findIndex((p) => p.id === id);
          if (index >= 0) {
            this.productGroups.items.splice(index, 1);
            useLocalStorage().setItem('productGroups', this.productGroups);
          }
        }
        return data;
      } catch (error) {
        throw apiErrorMessage(error);
      }
    },
  },
});
